export enum Baixar {
  DOCUMENTO_INTEIRO = '0',
  INTERVALO_PAGINAS = '1',
  MARCADORES = '2',
}

export enum NivelDeCompressao {
  ORIGINAL = '0',
  RECOMENDADA = '1',
  EXTREMA = '2',
}
